<template>
  <v-container class="newEstate-container d-flex justify-center">
    <div>
      <div class="form-header">
        <img width="75px" height="75px" src="images/new-estate.svg" alt="" />
        <h1>{{ $t("newEstateWelcome") }}</h1>
        <h2>{{ $t("newEstateText") }}</h2>
      </div>
      <form @submit.prevent="submit" style="width: 90%" class="px-5">
        <!-- Property Type -->
        <label class="subtitle1">{{ $t("PropertyTypeQuestionLabel") }}</label>
        <selectComponent
          style="background-color: #e8eaed; padding: 4px 10px"
          class="my-5"
          :label="$t('searchHouse')"
          :items="EstateTypes"
          attr="estate_type_id"
          @select="
            (val) => {
              form.estate_type_id = val.value;
            }
          "
        />

        <!-- Estate Offer Type -->
        <label class="subtitle1"> {{ $t("estateTypeQuestion") }}</label>
        <v-row class="my-3">
          <v-radio-group v-model="form.estate_offer_type_id" row>
            <v-radio :label="$t('sale')" value="1" class="mr-3" />
            <v-radio :label="$t('rent')" value="2" class="mr-3" />
          </v-radio-group>
        </v-row>

        <label class="subtitle1">{{
          " * " + $t("selectPropertyLocation")
        }}</label>
        <selectComponent
          style="background-color: #e8eaed; padding: 4px 10px"
          class="my-5"
          :errorMessages="location_idErrors"
          :label="$t('searchPlace')"
          :items="Locations"
          attr="location_id"
          @select="
            (val) => {
              form.location_id = val.value;
            }
          "
        />

        <label class="subtitle1">{{ " * " + $t("writePropertyArea") }}</label>
        <v-text-field
          :placeholder="$t('areaUnit')"
          v-model="form.area"
          class="my-6"
          style="background-color: #e8eaed; padding-inline: 5px"
          height="15.16px"
          :error-messages="areaErrors"
          required
          type="number"
        />
        <v-row class="my-3 mx-0">
          <label class="subtitle1">{{ $t("finishingStatus") }}</label>
          <v-radio-group v-model="form.estate_finishing" row>
            <v-row class="my-3">
              <v-flex
                class="d-flex flex-wrap"
                style="gap: 18px; justify-content: space-center"
              >
                <v-radio
                  :label="$t('structuralFrame')"
                  value="1"
                  class="mr-3"
                />
                <v-radio
                  :label="$t('mediumFinishing')"
                  value="2"
                  class="mr-3"
                />
                <v-radio :label="$t('newFinishing')" value="3" class="mr-3" />
                <v-radio
                  :label="$t('excellentFinishing')"
                  value="4"
                  class="mr-3"
                />
                <v-radio
                  :label="$t('partialFinishing')"
                  value="5"
                  class="mr-3"
                />
                <v-radio :label="$t('shellState')" value="6" class="mr-3" />
              </v-flex>
            </v-row>
          </v-radio-group>
        </v-row>

        <!-- Estate Ownership Question -->
        <label class="subtitle1">{{ $t("estateOwnershipQuestion") }}</label>
        <v-row class="my-3">
          <v-radio-group v-model="form.estate_ownership" row>
            <v-radio :label="$t('EstateOwner')" value="1" class="mr-3" />
            <v-radio :label="$t('EstateAgent')" value="2" class="mr-3" />
            <v-radio :label="$t('EstateOther')" value="3" />
          </v-radio-group>
        </v-row>

        <!-- Fullname -->
        <label class="subtitle1">{{ " * " + $t("Fullname") }}</label>
        <v-text-field
          v-model="form.fullname"
          class="my-6"
          style="background-color: #e8eaed; padding-inline: 5px"
          height="15.16px"
          :error-messages="fullnameErrors"
          required
        />

        <!-- Mobile Number -->
        <label class="subtitle1">{{ " * " + $t("mobilenumber") }}</label>
        <v-text-field
          placeholder="+963"
          v-model="form.mobile"
          class="my-6"
          style="background-color: #e8eaed; padding-inline: 5px"
          height="15.16px"
          :error-messages="mobileErrors"
          required
          type="tel"
        />

        <!-- information  -->
        <label class="subtitle1">{{ " * " + $t("moreInfo") }}</label>
        <v-textarea
          class="my-3"
          v-model="form.subject"
          style="
            background-color: #e8eaed;
            padding-inline: 5px;
            border-radius: 7.41906px;
          "
          rows="3"
          background-color="#e8eaed"
          :error-messages="subjectErrors"
          required
          dense
          @input="$v.form.subject.$touch()"
          @blur="$v.form.subject.$touch()"
        />
        <!-- Submit Button -->
        <v-btn
          block
          class="d-bg-primary d-text-light mt-3"
          type="submit"
          style="height: 40px"
          :loading="loading"
        >
          {{ $t("addOffer") }}
        </v-btn>
      </form>
    </div>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapActions, mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import { numeric } from "vuelidate/lib/validators";
import i18n from "@/i18n";
import axios from "axios";

export default {
  mixins: [validationMixin],

  data: () => ({
    myapi: "https://swess.store/api/v2/estate/add",
    loading: false,
    tab: "",
    formData: {},
  }),

  validations: {
    form: {
      estate_type_id: {},
      estate_offer_type_id: {},
      estate_ownership: {},
      subject: { required, maxLength: maxLength(2000) },
      fullname: { required },
      mobile: { required, numeric },
      location_id: { required },
      area: { required, numeric },
      estate_finishing: {},
    },
  },

  computed: {
    ...mapGetters(["getEstateTypes", "getLocations"]),
    location_idErrors() {
      const errors = [];
      if (!this.$v.form.location_id.$dirty) return errors;
      !this.$v.form.location_id.required &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "يرجى اختيار الموقع"
            : "Please select a city"
        );
      return errors;
    },
    estateOwnershipErrors() {
      const errors = [];
      if (!this.$v.form.estate_ownership.$dirty) return errors;
      !this.$v.form.estate_ownership.required &&
        errors.push("Please select an ownership type");
      return errors;
    },

    estate_type_idErrors() {
      const errors = [];
      if (!this.$v.form.estate_type_id.$dirty) return errors;
      !this.$v.form.estate_type_id.required &&
        errors.push("Please select a property type");
      return errors;
    },
    fullnameErrors() {
      const errors = [];
      if (!this.$v.form.fullname.$dirty) return errors;
      !this.$v.form.fullname.required &&
        errors.push(
          this.$i18n.locale == "ar" ? "الاسم مطلوب" : "Full name is required"
        );
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.form.mobile.$dirty) return errors;
      !this.$v.form.mobile.required &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "رقم الجوال مطلوب"
            : "Mobile number is required"
        );
      !this.$v.form.mobile.numeric &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "رقم الجوال يجب ان يكون رقم"
            : "Mobile number should be numeric"
        );
      return errors;
    },
    areaErrors() {
      const errors = [];
      if (!this.$v.form.area.$dirty) return errors;
      !this.$v.form.area.required &&
        errors.push(
          this.$i18n.locale == "ar" ? "المساحة مطلوبة" : "Area is required"
        );
      !this.$v.form.area.numeric &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "المساحة يجب ان تكون رقم"
            : "Area should be numeric"
        );
      return errors;
    },
    subjectErrors() {
      const errors = [];
      if (!this.$v.form.subject.$dirty) return errors;
      !this.$v.form.subject.required &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "المعلومات الاضافية مطلوبة"
            : "information is required"
        );
      !this.$v.form.subject.maxLength &&
        errors.push(
          this.$i18n.locale == "ar"
            ? "المعلومات يجب ان تكون اقل من 2000 حرف"
            : "Information must be less than 2000 characters"
        );
      return errors;
    },
    form() {
      return this.$store.getters.getUser;
    },
    EstateTypes() {
      return this.getEstateTypes;
    },
    Locations() {
      return this.getLocations;
    },
  },

  methods: {
    ...mapActions(["fetchEstateTypes", "fetchLocations"]),
    submit() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        // Create form data object
        const formData = {
          estate_type_id: this.form.estate_type_id,
          estate_offer_type_id: this.form.estate_offer_type_id,
          estate_ownership: this.form.estate_ownership,
          subject: this.form.subject,
          fullname: this.form.fullname,
          mobile: this.form.mobile,
          location_id: this.form.location_id,
          area: this.form.area,
          estate_finishing: this.form.estate_finishing,
        };

        // Set loading state to true
        this.loading = true;

        // Send the form data to the API using axios
        axios
          .post(this.myapi, formData)
          .then((response) => {
            this.loading = false; // Stop loading
            console.log(response.data); // Handle success response
            alert("Offer submitted successfully!");
          })
          .catch((error) => {
            this.loading = false; // Stop loading
            console.error(error); // Handle error
            alert("Error submitting offer. Please try again.");
          });
      }
    },
    setOfferType(type, id) {
      this.tab = type;
      this.form.estate_offer_type_id = id;
    },
  },

  mounted() {
    this.$store.dispatch("setLoad", false);
    this.fetchEstateTypes();
    this.fetchLocations("locations");
  },
};
</script>

<style scoped>
/* General Styles */
* {
  font-family: "Droid", "Effra" !important;
}

/* Form Header */
.form-header {
  text-align: center;
  margin-bottom: 25px;
}
.form-header h1 {
  font-size: 20px;
}
.form-header h2 {
  font-size: 14px;
  font-weight: 400;
}

/* Container Styling */
.newEstate-container > div {
  width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  background-color: rgba(33, 112, 180, 0.06);
  box-shadow: 0 3px 3px -1px rgba(0, 0, 0, 0.4);
  border-radius: 10px;
}

/* Button Active/Inactive States */
.d-bg-primary {
  background-color: #007bff;
}
.d-bg-inactiv {
  background-color: #e9ecef;
}
.d-text-light {
  color: #fff;
}
.d-text-dark {
  color: #212529;
}
@media screen and (max-width: 767px) {
  .newEstate-container > div {
    width: 600px;
  }
}
@media screen and (max-width: 350px) {
  .form-header h1 {
    font-size: 17px;
  }
  .form-header h2 {
    font-size: 11px;
  }
  button.chat-button p {
    font-size: 14px !important;
  }
  button.chat-button i {
    font-size: 20px !important;
  }
}
</style>
